import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const FormPinSchema = yup.object({
  currentPassword: yup.string().required('store_core:please_provide_current_password').default(''),
  pin: yup.string().required('store_core:provide_new_pin').min(4, 'store_core:pin_must_contain_4_digits').default(''),
  confirmPin: yup
    .string()
    .required('store_core:please_confirm_new_pin')
    .oneOf([yup.ref('pin')], 'store_core:pin_mismatch')
    .default(''),
});

export const useFormPin = () => {
  return useForm({ resolver: yupResolver(FormPinSchema) });
};
